import { useMutation } from '@tanstack/react-query';

type RollbackJobChangeProcessParams = {
  jobChangeProcessId: number;
};

export default function useRollbackJobChangeProcess() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ jobChangeProcessId }: RollbackJobChangeProcessParams) => {
      const response = await fetch(`/agent/api/job_change_processes/${jobChangeProcessId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || '処理に失敗しました');
      }

      return await response.json();
    },
  });
}
